import React from 'react'
import _ from 'lodash'
import moment from 'moment'

import DayBlockContainer from '../dayblock/dayblock.container'


export class DayGrid extends React.Component {
    render() {
        const dayBlocks = _.times(this.props.totalDays, (idx) => {
            let removeDay = () => {
                this.props.onRemoveDay(idx)
            }

            return (
                <DayBlockContainer
          dayNumber={idx + 1}
          key={idx}
          onRemoveDay={removeDay}
          width={this.props.dayWidth}/>
            )
        })

        return (
            <div id="day-block-container">
                {dayBlocks}
            </div>
        )
    }
}
